"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _common = _interopRequireDefault(require("../../styles/common.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FieldBlock =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FieldBlock, _React$Component);

  function FieldBlock() {
    _classCallCheck(this, FieldBlock);

    return _possibleConstructorReturn(this, _getPrototypeOf(FieldBlock).apply(this, arguments));
  }

  _createClass(FieldBlock, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          field = _this$props.field,
          comment = _this$props.comment,
          showErrorsImmediately = _this$props.showErrorsImmediately,
          size = _this$props.size;
      var label = this.props.label ? _react.default.createElement("label", {
        className: "control-label"
      }, this.props.label) : null;
      var sizeClass = 'form-group-' + size;
      var className = (0, _classnames.default)(['form-group', sizeClass, {
        'has-error': (field.touched || showErrorsImmediately) && field.error
      }]);
      return _react.default.createElement("div", {
        className: className,
        style: this.props.style
      }, label, comment && _react.default.createElement("div", {
        className: _common.default.comment
      }, comment), this.props.children, (field.touched || showErrorsImmediately) && field.error && _react.default.createElement("div", {
        className: "help-block"
      }, field.error));
    }
  }]);

  return FieldBlock;
}(_react.default.Component);

exports.default = FieldBlock;

_defineProperty(FieldBlock, "propTypes", {
  field: _propTypes.default.object.isRequired,
  label: _propTypes.default.node,
  comment: _propTypes.default.node,
  children: _propTypes.default.node,
  showErrorsImmediately: _propTypes.default.bool,
  style: _propTypes.default.object,
  size: _propTypes.default.string,
  placeholder: _propTypes.default.string
});

_defineProperty(FieldBlock, "defaultProps", {
  label: null,
  placeholder: '',
  showErrorsImmediately: true,
  style: {},
  // Options: 'sm', 'md', 'lg'
  size: 'sm'
});